<template>
  <span>{{ seconds }} second(s) ago</span>
</template>

<script>
export default {
  name: "elapsed",
  props: ["time"],
  data() {
    return {
      secondInterval: null,
      seconds: "-"
    };
  },
  created() {
    this.secondInterval = setInterval(this.updateTime, 1000);
  },
  beforeDestroy() {
    clearInterval(this.secondInterval);
  },
  methods: {
    updateTime() {
      if (this.time) {
        const millis = new Date().getTime() - new Date(this.time).getTime();
        this.seconds = Math.floor(millis / 1000);
      } else {
        this.seconds = "-";
      }
    }
  }
};
</script>
